import { useState } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";
import { Button } from "@/components/ui/button";

const STORAGE_KEY = "circlo-announcement-dismissed";

const AnnouncementBanner = () => {
  const [dismissed, setDismissed] = useState(
    () => sessionStorage.getItem(STORAGE_KEY) === "1"
  );

  if (dismissed) return null;

  const dismiss = () => {
    sessionStorage.setItem(STORAGE_KEY, "1");
    setDismissed(true);
  };

  return (
    <div
      role="region"
      aria-label="Announcement"
      className="bg-foreground text-primary-foreground"
    >
      <div className="relative container mx-auto px-12 py-3 text-center">
        <p className="text-sm font-medium leading-relaxed">
          We're refreshing our site. New work and photography landing soon.{" "}
          <Link
            to="/contact"
            className="font-bold underline underline-offset-4 hover:opacity-80 transition-opacity whitespace-nowrap"
          >
            Talk to us now →
          </Link>
        </p>
        <Button
          type="button"
          variant="ghost"
          size="icon"
          onClick={dismiss}
          aria-label="Dismiss announcement"
          className="absolute right-2 top-1/2 -translate-y-1/2 text-primary-foreground/70 hover:text-primary-foreground focus-visible:ring-primary-foreground/60 rounded"
        >
          <X className="w-4 h-4" />
        </Button>
      </div>
    </div>
  );
};

export default AnnouncementBanner;
